import InputAddress from './InputAddress'

export default InputAddress



// WEBPACK FOOTER //
// ./src/components/InputAddress/index.js